import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { processDomainDataLists, getDateStringFromWeek } from './DealsDataHelper';
import DealMap from './DealMap';


//const DealDisplay = ({ obj }) => {
const DealDisplayDetail = (props) => {
  let obj = props['deal'];
  let click_pos = props['click_pos'];
  let click_x = click_pos['click_x'];
  let click_y = click_pos['click_y'];



  let sdatestr = obj.accommodations['start_date'];
  let edatestr = obj.accommodations['end_date'];

  //console.log('ds', ds);



  // return (
  //   <div style={{ border: "2px solid blue", padding: "5px", width: "300px", height: "220px", overflowY: "hidden", margin: "5px" }}>
  //     <p><a href={obj.booking_url}>book</a></p>
  //     <p style={{ borderBottom: "1px solid black" }}>{obj.title}</p>
  //     <span>price={obj.price}</span>&nbsp;<span>ppn={obj.ppn}</span>&nbsp;<span>lok={obj.lok}</span>
  //     <div>{obj.property['name']}</div>
  //     <div>
  //       <span>{obj.property['city']}</span>,&nbsp;<span>{obj.property['state']}</span>
  //     </div>
  //     <div>
  //       <span>lat {obj.property['latitude']}</span>&nbsp;<span>lon {obj.property['longitude']}</span>
  //     </div>
  //     <div>
  //       <span>photo url </span>
  //     </div>
  //     {/* {obj.photos['url']} <div>{obj.photos[0]['url']}</div> */}
  //   </div>
  // )
  //http://www.myresortnetwork.com/images/resortPics/2038a.jpg
  // let parts = obj['photos']['url'].split('/');
  //let imgname = parts[parts.length - 1];
  //let imgsrc = 'http://ldphotos.s3.amazonaws.com/' + obj['photo_path'] + '.jpg';
  //let imgsrc = 'http://ldphotos.s3.amazonaws.com/' + obj['photoary'][0]['filename'];
  let imgsrc = 'http://' + obj['photo_path'] + '.s3.amazonaws.com/' + obj['photoary'][0]['filename'];

  //let imgsrc = 'http://ldphotos.s3.amazonaws.com/17824.jpg';
  //<div className="dealdisplaydetail" style={{ top: click_y, left: (click_x - 100) }}>

  return (

    <div className="dealdisplaydetail" style={{ top: click_y, left: 0, right: 0, margin: "auto" }}>
      <div className="row">
        <div className="col-md-10">
          <b>{obj.accommodations.title}</b>
          &nbsp;<span>{obj['id']}</span>
        </div>
        <div className="col-md-2">
          <a className="btn btn-xs btn-info"
            href="#" onClick={(e) => props.onClose(e)} >close</a>
        </div>
      </div>
      <hr />

      <div className="row" style={{ marginTop: "10px" }}>
        <div className="col-md-6"><b>Address</b></div>
        <div className="col-md-3"><b>Check In</b></div>
        <div className="col-md-3"><b>Check Out</b></div>
      </div>
      <div className="row">
        <div className="col-md-6">{obj['address']}&nbsp;{obj['city']}, {obj['state']}</div>
        <div className="col-md-3"> {sdatestr}</div>
        <div className="col-md-3">{edatestr}</div>
      </div>






      <div className="row" style={{ marginTop: "10px" }}>

        <div className="col-md-2" ><b>price</b></div>
        <div className="col-md-2"><b>ppn</b></div>
        <div className="col-md-2"><b>nights</b></div>
        <div className="col-md-2"><b>latitude</b></div>
        <div className="col-md-2"><b>longitude</b></div>
        <div className="col-md-2">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col-md-2">{obj.accommodations.price}</div>
        <div className="col-md-2">{obj.accommodations.ppn}</div>
        <div className="col-md-2">{obj.accommodations.lok}</div>
        <div className="col-md-2">{obj['latitude']}</div>
        <div className="col-md-2">{obj['longitude']}</div>
        <div className="col-md-2">&nbsp;</div>
      </div>




      <div className="row" style={{ marginTop: "10px" }}>
        <div className="col-md-12">
          <b>Description:</b>&nbsp;{obj['description']}
        </div>
      </div>

      <div className="row" style={{ marginTop: "10px" }}>
        <div className="col-md-4">
          <img width="200" height="200" src={imgsrc} />
        </div>
        <div className="col-md-8">
          <DealMap deal={obj} lat={obj['latitude']} lon={obj['longitude']} />
        </div>
      </div>
      <div className="row" style={{ marginTop: "10px" }}>
        <div className="col-md-10">
          {imgsrc}
        </div>
        <div className="col-md-2">
          {/* <a href={obj.accommodations.booking_url}>book</a> */}
          <a className="btn btn-xs btn-info"
            href="#" onClick={(e) => props.gotoBooking(e, obj.accommodations.booking_url)} >book</a>
        </div>
      </div>





    </div >
  )


  // return (
  //   <div style={{ borderBottom: "2px solid blue", padding: "5px" }}>
  //     <h4>{obj.booking_url}</h4>
  //     <h4 style={{ borderBottom: "1px solid black" }}>{obj.title}</h4>
  //     <span>price={obj.price}</span>&nbsp;<span>ppn={obj.ppn}</span>
  //     <div>{obj.property[0]['name']}</div>
  //     <div>
  //       <span>{obj.property[0]['city']}</span>,&nbsp;<span>{obj.property[0]['state']}</span>
  //     </div>
  //     <div>
  //       <span>lat {obj.property[0]['latitude']}</span>&nbsp;<span>lon {obj.property[0]['longitude']}</span>
  //     </div>
  //     {/* <div>{obj.photos[0]['url']}</div> */}
  //   </div>
  // )
  /*
   return (
    <div>
        <h4>{obj.price}</h4>
        <span>{obj.booking_url}</span>
      </div>
  )
  */

}



export default DealDisplayDetail;



// WEBPACK FOOTER //
// ./src/components/deals/DealDisplayDetail.js